import React from 'react';

const Footer = (props) => (
    <footer className="footer">
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                © {new Date().getFullYear()} ARTSMRKTS
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;